import Cookies from 'js-cookie'
// cookie保存的天数
import config from '@/config'

const { cookieExpires } = config

export const setCookie = (cookieName, cookieVal) => {
    Cookies.set(cookieName, cookieVal, { expires: cookieExpires || 1 })
}

export const getCookie = (cookieName) => {
    const cookieVal = Cookies.get(cookieName)
    if (cookieVal) return cookieVal
    else return false
}

// 函数节流
export const throttle = (func, wait) => {
    let lastTime = 0
    return function (...args) {
        const now = +new Date()
        if (now - lastTime > wait) {
            lastTime = now
            func.apply(this, args)
        }
    }
}

// 函数防抖
export const debounce = (func, wait) => {
    var timeout
    return function () {
        var context = this
        var args = arguments
        clearTimeout(timeout)
        timeout = setTimeout(function () {
            func.apply(context, args)
        }, wait)
    }
}

// Native 转换 Unicode
export const Native2Unicode = (str) => {
    var res = ''
    for (var i = 0; i < str.length; i++) {
        res += ('&#' + str.charCodeAt(i) + ';')
    }
    return res
}
// Unicode 转换 Native
export const Unicode2Native = (str) => {
    // console.log(str.length, str, '长度')
    var res = ''
    var code = str.match(/&#(\d+);/g)
    for (var i = 0; i < code.length; i++) {
        res += String.fromCharCode(code[i].replace(/[&#;]/g, ''))
    }
    return res
}
export const getOS = function() {
    var os = '0'
    if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1) {
      os = 2
    } else if (navigator.userAgent.indexOf('iPhone') > -1) {
      os = 1
    }
    return os
}
